// extracted by mini-css-extract-plugin
module.exports = {"cardList":"CardList_cardList__1AtKg"};